import { Link } from "react-router-dom";
import { hotTrends, feedPosts } from "@/mocks/guawa";

const featured = feedPosts[0];
const medal = ["bg-primary-500", "bg-accent-500", "bg-ink-500"];

export default function HotBoard() {
  const top = hotTrends.slice(0, 6);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* 今日热榜 */}
        <div className="rounded-2xl border border-cream-200 bg-white p-5 md:col-span-2">
          <div className="flex items-center justify-between">
            <h2 className="flex items-center gap-2 text-lg font-extrabold text-ink-900">
              <i className="ri-fire-fill text-primary-500"></i> 今日吃瓜热榜
            </h2>
            <Link
              to="/topics"
              className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-s-line"></i>
            </Link>
          </div>

          <ol className="mt-4 flex flex-col gap-3">
            {top.map((t) => (
              <li key={t.rank}>
                <a
                  href="#site-feed"
                  className="group flex items-center gap-3 rounded-xl px-3 py-2.5 transition-colors hover:bg-primary-50"
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold text-white ${
                      medal[t.rank - 1] ?? "bg-cream-300 text-ink-700"
                    }`}
                  >
                    {t.rank}
                  </span>
                  <span className="min-w-0 flex-1 truncate text-sm font-semibold text-ink-800 group-hover:text-primary-700">
                    {t.title}
                  </span>
                  <span className="hidden shrink-0 text-xs text-ink-400 sm:inline">{t.heat}</span>
                  <span className="inline-flex shrink-0 items-center gap-1 text-xs text-primary-600">
                    <i className="ri-message-3-line"></i> {t.comments.toLocaleString()}
                  </span>
                  {t.rising && (
                    <span className="inline-flex shrink-0 items-center gap-0.5 rounded-full bg-primary-50 px-2 py-0.5 text-[11px] font-semibold text-primary-600">
                      <i className="ri-arrow-up-line"></i> 升
                    </span>
                  )}
                </a>
              </li>
            ))}
          </ol>
        </div>

        {/* 本期焦点 */}
        <div className="flex flex-col rounded-2xl border border-cream-200 bg-white p-5">
          <h2 className="flex items-center gap-2 text-lg font-extrabold text-ink-900">
            <i className="ri-focus-3-fill text-accent-500"></i> 本期焦点
          </h2>
          <div className="mt-4 flex flex-1 flex-col">
            {featured.badge && (
              <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-semibold text-accent-700">
                <i className="ri-flashlight-fill"></i> {featured.badge}
              </span>
            )}
            <h3 className="mt-3 text-lg font-bold leading-snug text-ink-900">
              <Link to="/topic/discuss-2026" className="transition-colors hover:text-primary-700">
                {featured.title}
              </Link>
            </h3>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-ink-500">{featured.excerpt}</p>
            <div className="mt-4 flex items-center justify-between border-t border-cream-200 pt-4 text-xs text-ink-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-thumb-up-line text-primary-500"></i> {featured.likes.toLocaleString()}
                <span className="ml-2 inline-flex items-center gap-1">
                  <i className="ri-chat-3-line text-accent-500"></i> {featured.comments.toLocaleString()}
                </span>
              </span>
              <Link
                to="/topic/discuss-2026"
                className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-accent-600 whitespace-nowrap"
              >
                去围观 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}